/* eslint-disable no-mixed-operators */
/* eslint-disable no-nested-ternary */

export const secondsToDhms = (seconds) => {
  const secs = Number(seconds);
  const d = Math.floor(secs / (3600 * 24));
  const h = Math.floor((secs % (3600 * 24)) / 3600);
  const m = Math.floor((secs % 3600) / 60);
  const s = Math.floor((secs % 3600) % 60);

  const dDisplay = d >= 0 ? (d < 10 ? `0${d}` : d.toString()) : '';
  const hDisplay = h >= 0 ? (h < 10 ? `0${h}` : h.toString()) : '';
  const mDisplay = m >= 0 ? (m < 10 ? `0${m}` : m.toString()) : '';
  const sDisplay = s >= 0 ? (s < 10 ? `0${s}` : s.toString()) : '';

  return [dDisplay, hDisplay, mDisplay, sDisplay];
};

export const dateShort = (value) => {
  const d = new Date(value);
  const ye = new Intl.DateTimeFormat('en', { year: 'numeric' }).format(d);
  const mo = new Intl.DateTimeFormat('en', { month: 'short' }).format(d);
  const da = new Intl.DateTimeFormat('en', { day: '2-digit' }).format(d);

  return `${da}. ${mo} ${ye}`;
};

/**
 * Converts the given amount and currency into the shop currency.
 * (This is useful for e.g. orders that cam be both in JPY and USD)
 *
 * @param {number} amount to be converted
 * @param {string?} currency if the currency is not provided we'll use the shop currency
 * @returns {string} `<span class="money">¥1,000</span>`
 */
export const money = (amount, setCurrency = null) => {
  let currency = window.shopCurrency;
  if (setCurrency) {
    currency = setCurrency;
  }

  let convertedPrice = amount;
  if (currency !== window.shopCurrency) {
    convertedPrice = Math.round(Currency.convert(amount, currency, window.shopCurrency));
  }

  return Shopify.formatMoney(convertedPrice, Shopify.money_format);
};

export const formatMoney = (amount, currency) => {
  const format = Currency.moneyFormats[currency].money_format;
  return Shopify.formatMoney(amount, format);
};

export const shopifyCents = (amount, currency) => {
  if (currency === 'JPY') return amount * 100;

  return amount;
};

export default {
  dateShort,
  money,
  formatMoney,
  secondsToDhms,
  shopifyCents,
};
